import { useEffect } from 'react';
import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { useContextSelector as useCS } from 'use-context-selector';
import {
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import { TUpdate } from 'domain/types';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { showSystemToast } from 'view/components/SystemToast';

export const useHideOrShowAccount = (): any => {
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );
  const globalUpdate: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  const { data, isLoading, error, status, send } = useRequest({
    url: '/api/v1/auth/me',
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
  });

  const updateAccountPrivacy = (body: { showProfile: boolean }) => {
    send({ privacySettings: body }).then();
  };

  useEffect(() => {
    if (!isLoading && !error && status === 200) {
      const showProfile: boolean = data?.privacySettings?.showProfile;
      if (globalUpdate) globalUpdate({ userData: data });
      if (update)
        update(showProfile ? { isOpenShowAccountModal: false } : { isOpenHideAccountModal: false });
      if (showProfile) {
        showSystemToast(
          'success',
          'Profile visibility updated',
          'Your profile is now visible to others.'
        );
      } else {
        showSystemToast(
          'success',
          'Profile visibility updated',
          'Your profile is now hidden from others.'
        );
      }
    }
  }, [isLoading, error, status]);

  return {
    isLoading,
    error: error || null,
    updateAccountPrivacy,
  };
};
